import React from 'react';
import { observer } from 'mobx-react';
import { EventHubWebsiteBuilderVM } from './event-hub-website-builder.viewmodel';
import { WebsiteBuilderHeader } from './_header/website-builder-header';
import { WebsiteBuilderContent } from './_content/website-builder-content';
import { WebsiteBuilderSidebar } from './_sidebar/website-builder-sidebar';
import './event-hub-website-builder.scss';

export type EventHubWebsiteBuilderPresentationProps = {
    vm: EventHubWebsiteBuilderVM;
};

export const EventHubWebsiteBuilderPresentation = observer(({ vm }: EventHubWebsiteBuilderPresentationProps) => {
    return (
        <div className='event-hub-website-builder'>
            <WebsiteBuilderHeader onBack={vm.navigateBack} hubName={vm.getHubName()} hubUrl={vm.getHubUrl()} />
            <div className='event-hub-website-builder__body'>
                <WebsiteBuilderContent
                    hubUrl={vm.getHubUrl()}
                    hubEmbedRefreshKey={vm.getHubEmbedRefreshKey()}
                    isHubEmbedRefreshing={vm.isHubEmbedRefreshing()}
                />
                {vm.getPreviewVersionId() && (
                    <WebsiteBuilderSidebar
                        versionId={vm.getPreviewVersionId()}
                        accountId={vm.getAccountId()}
                        eventHubId={vm.getEventHubId()}
                        onHubPreviewRefresh={vm.getHubPreviewRefresh()}
                    />
                )}
            </div>
        </div>
    );
});
